<template>
  <div class="container" :style="{ '--fondo-aleatorio': `url(${fondoUrl})`}">
    <div class="slide" id="slide">
      <div class="controles">
        <button @click="cambiarLetra('-')" class="botonesControles"> A- </button>
        <button @click="cambiarLetra('+')" class="botonesControles"> A+ </button>
        <button @click="cambiarColor()" class="botonesControles"> {{ tema == 'Claro' ? '☀️' : '🌑' }} </button>
      </div>

      <div v-if="mostrarVotos" class="controlesVotos">
        <button @click="enviarOpinion('L')" class="botonesOpinion-L">👍</button>
        <button @click="enviarOpinion('D')" class="botonesOpinion-D">👎</button>
      </div>

      <a v-if="tema == 'Claro'" href="https://www.funifelt.com/" target="_blank"><img src="@/assets/images/Logo_Funifelt_Color.png" class="logo"></a>
      <a v-else href="https://www.funifelt.com/" target="_blank"><img src="@/assets/images/Logo_Funifelt_Blanco.png" class="logo"></a>

      <h1 id="titulo">{{ titulo }}</h1>
      <audio controls controlslist="nodownload" id="audioRelato">
        <source v-bind:src="audios" type="audio/mpeg">
        Tu navegador no soporta este elemento de audio.
      </audio>
      <div class="texto-contenedor">
        <p id="contenedor_de_relato"></p>
        <img class="logo_fondo" src="https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Ffunifelt.png?alt=media&token=e1714394-9f4a-4279-935b-2df7062fbd70">
      </div>
    </div>
  </div>
</template>

<style>
  .actual {
    background-color: rgb(246, 228, 162);
    border-radius: 5px;
    font-weight: bold;
  }
</style>

<script>
import { db } from '@/main.js'
import { collection, query, where, getDocs, setDoc, doc, addDoc, increment, arrayUnion, arrayRemove } from 'firebase/firestore'
import { getAuth } from 'firebase/auth'

export default {
  props: {
    relato: String, // Recibir el titulo del relato a consultar
    categoria: String // Recibir la categoria del relato a consultar
  },
  setup: async (props) => { // Consultar en la base de datos
    const categoriaABuscar = props.categoria.charAt(0).toUpperCase() + props.categoria.slice(1)
    const relatoABuscar = props.relato
    const userID = getAuth().currentUser.uid

    const coleccionDeRelatos = collection(db, categoriaABuscar) // Acceder a la coleccion (categoria) en la base de datos
    let queryTitulo
    let queryTexto
    let queryAudio
    let queryPartes
    let queryTema
    let queryFontSize

    let debeVotar
    let queryListaLikes
    let queryListaDislikes

    const q = query(coleccionDeRelatos, where('Titulo', '==', relatoABuscar)) // Hacer la consulta por el titulo del relato a buscar
    const querySnapshot = await getDocs(q)
    querySnapshot.forEach((doc) => {
      queryTitulo = doc.data().Titulo
      queryTexto = doc.data().Texto
      queryAudio = doc.data().Audio // Enlace al archivo de audio en Firebase Storage
      queryPartes = doc.data().Partes
    })


    // Consultar las preferencias del usuario
    const coleccionDeUsuarios = collection(db, 'Usuarios') // Acceder a la coleccion (Usuarios) en la base de datos
    const qUsers = query(coleccionDeUsuarios, where('UID', '==', userID)) // Hacer la consulta por el correo del usuario
    const querySnapshotUsers = await getDocs(qUsers)
    querySnapshotUsers.forEach((doc) => {
      queryTema = doc.data().tema
      queryFontSize = doc.data().fontSize
    })


    // Consultar si el usuario ya dio like o dislike a este relato
    const coleccionDePuntajes = collection(db, 'PuntajesRelatos') // Acceder a la coleccion (puntajesRelastos) en la base de datos
    const qPuntajes = query(coleccionDePuntajes, where('tituloRelato', '==', queryTitulo)) // Hacer la consulta de las listas de likes y dislikes
    const querySnapshotPuntajes = await getDocs(qPuntajes)
    querySnapshotPuntajes.forEach((doc) => {
      queryListaLikes = doc.data().like
      queryListaDislikes = doc.data().dislike
    })

    // Verificar si el usuario ya dio like o dislike
    if (queryListaLikes.users.includes(userID)) {
      debeVotar = false
    } else if (queryListaDislikes.users.includes(userID)) {
      debeVotar = false
    } else {
      debeVotar = true
    }


    return { 
      queryTitulo, 
      queryTexto, 
      queryAudio,
      queryPartes,
      
      // Preferencias esteticas del usuario
      queryTema,
      queryFontSize,

      debeVotar
    }
  },
  data: () => { // Crear las variables para enviar al template
    return {
      titulo: '',
      texto: '',
      audios: '',
      fondoUrl: '',

      // Preferencias esteticas del usuario
      cambios: false,
      tema: 'Claro',
      fontSize: null,

      // Variables para tomar el tiempo dentro del relato
      inicioSesion: null,

      mostrarVotos: false,
    }
  },
  mounted () { // Actualizar los valores del template con los datos obtenidos en las consultas a la base de datos
    this.titulo = this.queryTitulo 
    this.texto = this.queryTexto
    this.audios = this.queryAudio

    // Mostrar los botones de like y dislike si el usuario no ha votado
    this.mostrarVotos = this.debeVotar

    // Aplicar las preferencias de tema (colores) del usuario
    this.tema = this.queryTema
    const colorClaro = { fondo: 'white', titulo: '#25274F', letra: '#3B5CAB' }
    const colorOscuro = { fondo: '#212121', titulo: 'white', letra: '#94A2CB' }

    let element = document.getElementById('slide')
    let texto = document.getElementById('contenedor_de_relato')
    let titulo = document.getElementById('titulo')

    if (this.tema == 'Claro') {
      element.style.backgroundColor = colorClaro.fondo
      texto.style.color = colorClaro.letra
      titulo.style.color = colorClaro.titulo
    } else {
      element.style.backgroundColor = colorOscuro.fondo
      texto.style.color = colorOscuro.letra
      titulo.style.color = colorOscuro.titulo
    }
    

    // Aplicar las preferencias de tamaño de letra del usuario
    this.fontSize = this.queryFontSize
    texto.style.fontSize = `${this.fontSize}px` 
    

    // Cambiar el titulo de la ventana
    document.title = 'Relatos - ' + this.titulo

    this.elegirFondo()

    // Funcion para separar el texto por '.' y ','
    function separarTexto(texto) {
      let textoSeparado = []
      let parte = ''
      for (let letra in texto) {
        if (texto[letra] == '^') { // Si encuentra un '^' lo reemplaza por un salto de linea
          parte += '<br><br>'
        } else if (texto[letra] != ',' && texto[letra] != '.') { // Si no encuentra un '.' o ',' lo agrega al arreglo (parte)
          parte += texto[letra]
        } else { // Si encuentra un '.' o ',' agrega la parte al arreglo y reinicia la variable parte
          parte += texto[letra]
          textoSeparado.push(parte)
          parte = ''
        }
      }
      textoSeparado.push(parte)
      return textoSeparado
    }

    // Crear las partes del texto en para el template
    let relato = separarTexto(this.texto)
    let contenidoDelRelato = ''
    for (let parte in relato) {
      contenidoDelRelato += `<span id="${parte}"> ${relato[parte]}</span>`
    }
    document.getElementById('contenedor_de_relato').innerHTML = contenidoDelRelato

    document.getElementById('audioRelato').onplay = () => {
      this.seguirAudio()
    }

    // Registrar la visualizacion del relato
    this.registrarVisualizacion()
  },
  beforeMount () {
    // Obtener la hora actual
    const date = new Date()
    this.inicioSesion = date
  },
  async beforeUnmount () {
    // Obtener la hora actual
    const date = new Date()

    // Comparar el tiempo de inicio y fin de sesion
    let diff = date.getTime() - this.inicioSesion.getTime()
    let segundos = Math.floor(diff / 1000) % 60
    let minutos = Math.floor(diff / (1000 * 60)) % 60
    let horas = Math.floor(diff / (1000 * 60 * 60))
    let tiempoTotal = `${horas}:${minutos}:${segundos}`


    // Guardar informacion de la sesion en la base de datos de firebase
    const docRef = await addDoc(collection(db, "Sesiones"), {
      tituloRelato: this.titulo,
      userID: getAuth().currentUser.uid,
      inicio: this.inicioSesion,
      fin: date,
      tiempo: tiempoTotal
    })


    // Guardar los cambios en las preferencias del usuario si hubo alguno
    if (this.cambios) {
      await setDoc(doc(db, 'Usuarios', getAuth().currentUser.email), {
        tema: this.tema,
        fontSize: this.fontSize
      }, { merge: true })
    }
  },
  methods: {
    elegirFondo () {
      const listaDeFondos = [
        'https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Ffondo1.png?alt=media&token=d1949877-0ec6-4f22-aeb0-108ec19093e4',
        'https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Ffondo2.png?alt=media&token=fb601488-43f9-4ab1-9c31-9128d65f9742',
        'https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Ffondo3.png?alt=media&token=9c0af348-4147-40a1-9f56-61f1b1ba965b',
        'https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Ffondo4.png?alt=media&token=3f9971b7-7b22-4e2f-8f2c-3d1be60d7c67',
        'https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Ffondo5.png?alt=media&token=b846abb6-b48c-4602-ad4b-675a960e1355',
        'https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Ffondo6.png?alt=media&token=b7b9ba50-9ed0-44eb-809b-91bd8b32d238',
        'https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Ffondo7.png?alt=media&token=c2a0f894-bb6b-4689-81e5-96b54c64f921',
        'https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Ffondo8.png?alt=media&token=75a856a3-741a-4181-81df-db5a715cb581',
        'https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Ffondo9.png?alt=media&token=ef9456b1-c4f1-4c55-89ec-f1963fd2517f',
        'https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Ffondo10.png?alt=media&token=976e08f0-96de-4593-997a-90086e2e759d',
        'https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Ffondo11.png?alt=media&token=94b72a08-8e89-4e70-8124-42fddfdf76e7',
        'https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Ffondo12.png?alt=media&token=07990ea0-4b31-48b3-b404-421510321977',
        'https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Ffondo13.png?alt=media&token=bdbbe5dd-7139-4106-ad9e-d1264586decf',
        'https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Ffondo14.png?alt=media&token=c946b63e-00f8-4f95-8ef6-92a7013b47cc',
        'https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Ffondo15.png?alt=media&token=4aa8d5b1-9c60-4a35-89d8-48dd115b34c9',
        'https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Ffondo16.png?alt=media&token=8ac81301-d1f4-4542-8891-b6f1ba02b4c7',
        'https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Ffondo17.png?alt=media&token=693e598c-cf7c-4391-aebb-2dcd024dd8ef',
        'https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Ffondo18.png?alt=media&token=7ea50d39-5f08-44b2-8236-f3d3f1a32a19',
        'https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Ffondo19.png?alt=media&token=695d965b-483b-44a0-aa9d-ea091922db85',
        'https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Ffondo20.png?alt=media&token=39b6db74-d530-481d-8022-6909bde83258',
        'https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Ffondo21.png?alt=media&token=423d23b3-d67a-4f34-81e6-bc27216f9993',
        'https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Ffondo22.png?alt=media&token=3e5dc70f-f238-4631-be06-c3dd762913e8',
        'https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Ffondo23.png?alt=media&token=ae201eea-b7b4-4933-928c-c7270f49c7b9',
        'https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Ffondo24.png?alt=media&token=fc3de8b2-918d-4a45-ae46-743c36afe2e6',
        'https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Ffondo25.png?alt=media&token=9b18dda5-6764-43fa-a5b4-d4af9c645da0',
        'https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Ffondo26.png?alt=media&token=2088499c-73a6-469d-97ac-991a66c91895',
        'https://firebasestorage.googleapis.com/v0/b/relatos-mitos-y-leyendas.appspot.com/o/Fondos%2Ffondo27.png?alt=media&token=f5c0ee3d-9473-4d3d-911b-c9c2750c709f'
      ]
      // Escoger aleatoriamente una imagen de la lista de fondos
      this.fondoUrl = listaDeFondos[Math.floor(Math.random() * listaDeFondos.length)]
    },
    seguirAudio () {
      let audio = document.getElementById('audioRelato')
      let parts = this.queryPartes
      audio.addEventListener('timeupdate', () => {
        Object.keys(parts).forEach(function(key) {
          let id = key
          let start = parseFloat(parts[key].split('-')[0])
          let end = parseFloat(parts[key].split('-')[1])

          if (start <= audio.currentTime && end >= audio.currentTime) {
            document.getElementById(id.toString()).className = "actual"
          } else {
            document.getElementById(id.toString()).className = ""
          }
        })
      })
    },
    cambiarLetra (operacion) {
      // Obtener el tamaño actual de la letra
      let element = document.querySelector('#contenedor_de_relato')
      let styles_applied = window.getComputedStyle(element)
      let actual_size = parseInt(styles_applied.fontSize.replace(/\D/g,''))
      let new_size
      if (operacion == '+') {
        new_size = actual_size + 1 
      } else {
        new_size = actual_size - 1 
      }
      document.getElementById('contenedor_de_relato').style.fontSize = `${new_size}px` 

      // Guardar el cambio en la base de datos
      this.fontSize = new_size
      this.cambios = true
    },
    cambiarColor () {
      const colorClaro = { fondo: 'white', titulo: '#25274F', letra: '#3B5CAB' }
      const colorOscuro = { fondo: '#212121', titulo: 'white', letra: '#94A2CB' }

      let element = document.getElementById('slide')
      let texto = document.getElementById('contenedor_de_relato')
      let titulo = document.getElementById('titulo')

      if (this.tema == 'Claro') {
        element.style.backgroundColor = colorOscuro.fondo
        texto.style.color = colorOscuro.letra
        titulo.style.color = colorOscuro.titulo
        this.tema = 'Oscuro'
      } else {
        element.style.backgroundColor = colorClaro.fondo
        texto.style.color = colorClaro.letra
        titulo.style.color = colorClaro.titulo
        this.tema = 'Claro'
      }

      // Guardar el cambio en la base de datos
      this.cambios = true
    },

    // Funciones para guardar la opinion del usuario en la base de datos (se puede reemplazar con cookies si es necesario)
    async enviarOpinion (opinion) {
      // Guardar el voto en la base de datos
      const docRef = doc(db, 'PuntajesRelatos', this.titulo)
      if (opinion == 'L') {        
        setDoc(docRef, {
          like: {
            counter: increment(1),
            users: arrayUnion(getAuth().currentUser.uid)
          }
        }, { merge: true }) 
      } else {
        setDoc(docRef, {
          dislike: {
            counter: increment(1),
            users: arrayUnion(getAuth().currentUser.uid)
          }
        }, { merge: true }) 
      }

      // Ocultar los botones de like y dislike
      this.mostrarVotos = false
    },

    registrarVisualizacion() {
      const docRef = doc(db, 'PuntajesRelatos', this.titulo)
      setDoc(docRef, {
        visualizaciones: increment(1)
      }, { merge: true })
    }
  }
}
</script>

<style src="@/assets/css/relatos.css" scoped></style>
